import React from 'react';
import "../less/quickCash.less"
import { Preloader } from 'MWC';
import Calculator from '../../../auxiliary-components/Calculator';
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import HowToBlock from "../../../auxiliary-components/shared/HowToBlock";
import how_to_img_1 from "../img/how_to_img_1.png";
import how_to_img_2 from "../img/how_to_img_2.png";
import how_to_img_3 from "../img/how_to_img_3.png";
import how_to_img_4 from "../img/how_to_img_4.png";
import how_to_img_5 from "../img/how_to_img_5.png";
import how_to_img_6 from "../img/how_to_img_6.png";
import how_to_img_8 from "../img/how_to_img_8.png";
import how_to_img_9 from "../img/how_to_img_9.png";
import how_to_img_10 from "../img/how_to_img_10.png";
import how_to_img_11 from "../img/how_to_img_11.png";
import how_to_img_12 from "../img/how_to_img_12.png";
import how_to_img_13 from "../img/how_to_img_13.png";
import how_to_img_14 from "../img/how_to_img_14.png";
import how_to_img_15 from "../img/how_to_img_15.png";
import quick_cash_usage_block from '../quick_cash_usage_block.json';
import quick_cash_usage_block_2 from '../quick_cash_usage_block_2.json';
import quick_cash_usage_block_3 from '../quick_cash_usage_block_3.json';
import quick_cash_usage_block_4 from '../quick_cash_usage_block_4.json';
import quick_cash_usage_block_5 from '../quick_cash_usage_block_5.json';
import quick_cash_repayment from '../quick_cash_repayment.json';
import QuickCashOrder from "../../QuickCashOrder";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import SliderComponent from '../../../auxiliary-components/shared/Slider';
import QuestionsAdminBlock from "../../../auxiliary-components/shared/QuestionsAdmin";

export default function template() {
    const model = this.getModel(),
        isMobile = this.isViewportMobile(),
        modal = this.state.showModal ? <QuickCashOrder closeModal={this.toggleModal} utmParams={this.utmParams} isMobile={isMobile}  loanTerm={this.state.loanTerm} loanSum={this.state.loanSum}/> : '',
        modes = [ {mode: 'info', title: 'CREDIT_QUICK_CASH_NAV_TITLE_1'},
          {mode: 'repayment', title: 'CREDIT_QUICK_CASH_NAV_TITLE_2'},
          {mode: 'questions', title: 'CREDIT_QUICK_CASH_NAV_TITLE_3'},
        {mode: 'special_offers', title: 'CREDIT_QUICK_CASH_NAV_TITLE_4'}],
        howToItems = [{ img: how_to_img_1, title: 'CREDIT_QUICK_CASH_HOW_TO_TITLE_1', text: 'CREDIT_QUICK_CASH_HOW_TO_TEXT_1' },
          { img: how_to_img_2, title: 'CREDIT_QUICK_CASH_HOW_TO_TITLE_2', text: 'CREDIT_QUICK_CASH_HOW_TO_TEXT_2' },
          { img: how_to_img_3, title: 'CREDIT_QUICK_CASH_HOW_TO_TITLE_3', text: 'CREDIT_QUICK_CASH_HOW_TO_TEXT_3' },],
      howToItems_2 = [{ img: how_to_img_4, title: 'CREDIT_QUICK_CASH_HOW_TO_2_TITLE_1', text: 'CREDIT_QUICK_CASH_HOW_TO_2_TEXT_1' },
        { img: how_to_img_5, title: 'CREDIT_QUICK_CASH_HOW_TO_2_TITLE_2', text: 'CREDIT_QUICK_CASH_HOW_TO_2_TEXT_2' },
        { img: how_to_img_6, title: 'CREDIT_QUICK_CASH_HOW_TO_2_TITLE_3', text: 'CREDIT_QUICK_CASH_HOW_TO_2_TEXT_3' },],
      howToItems_3 = [{ img: how_to_img_13, title: 'CREDIT_QUICK_CASH_HOW_TO_3_TITLE_1', text: 'CREDIT_QUICK_CASH_HOW_TO_3_TEXT_1' },
        { img: how_to_img_8, title: 'CREDIT_QUICK_CASH_HOW_TO_3_TITLE_2', text: 'CREDIT_QUICK_CASH_HOW_TO_3_TEXT_2' },
        { img: how_to_img_9, title: 'CREDIT_QUICK_CASH_HOW_TO_3_TITLE_3', text: 'CREDIT_QUICK_CASH_HOW_TO_3_TEXT_3' },],
      howToItems_4 = [{ img: how_to_img_10, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_1', text: 'CREDIT_QUICK_CASH_HOW_TO_4_TEXT_1' },
        { img: how_to_img_11, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_2', text: 'CREDIT_QUICK_CASH_HOW_TO_4_TEXT_2' },
        { img: how_to_img_12, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_3', text: 'CREDIT_QUICK_CASH_HOW_TO_4_TEXT_3' },],
      howToItems_5 = [{ img: how_to_img_14, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_1', text: 'CREDIT_QUICK_CASH_HOW_TO_5_TEXT_1' },
        { img: how_to_img_15, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_2', text: 'CREDIT_QUICK_CASH_HOW_TO_4_TEXT_2' },
        { img: how_to_img_12, title: 'CREDIT_QUICK_CASH_HOW_TO_4_TITLE_3', text: 'CREDIT_QUICK_CASH_HOW_TO_4_TEXT_3' },],
        quickCashCalcFile_1 = '/static/quickCash/calc_comfort.xlsx',
      quickCashCalcFile_2 = '/static/quickCash/calc_exclusive.xlsx',
      quickCashCalcFile_3 = '/static/quickCash/calc_zero.xlsx',
      mobileOrderBtn = isMobile && this.state.orderBtnMode ? (
        <button className="mobile-button-order"
                onClick={this.toggleModal}>
          {this.l10n('EXPRESS_APPLICATION_APPLY_BTN')}
        </button>
      ) : '';

    return !model.creditSum ?
        (<div className="preload-wrapper">
            <Preloader />
        </div>)
        : (
            <div className="quick-cash-block">
              <div className='qc-slider'>
                {this.state.loader ? <Preloader></Preloader> : <SliderComponent toggleModal={this.toggleModal} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, "main_banner")}></SliderComponent>}
              </div>
              <TabsNew modes={modes} isMobile={isMobile} page={'quick-cash'} toggle={this.toggleMode} mode={this.state.mode}>
                <div className="wrapper" type={modes[0].mode}>
                  <div className="content">
                    <UsageBlock isMobile={isMobile} page={"quick-cash-3"} data={quick_cash_usage_block} className="col-3-row-2"/>
                    <div id={'credit-calculator'} className="credit-calculator">
                      <div className="calculator-wrapper">
                        <Calculator model={this.getModel()} type={this.state.selectedType} toggleModal={this.toggleModal} isBtn={!(this.state.orderBtnMode && isMobile)} {...this.props} />
                      </div>
                    </div>
                    <div className='anchor'></div>
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("CREDIT_QUICK_CASH_HOW_TO_TITLE")}</div>
                      <HowToBlock data={howToItems} isMobile={isMobile} page={"shoping-atb"}/>
                    </div>
                  </div>
                </div>
                <div className="wrapper" type={modes[1].mode}>
                  <div className="content">
                    <UsageBlock isMobile={isMobile} page={"quick-cash"} data={quick_cash_repayment} className="col-3-row-1"/>
                  </div>
                </div>
                <div className="wrapper" type={modes[2].mode}>
                  <div className="content">
                    <QuestionsAdminBlock page={"quick-cash"} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                  </div>
                </div>
                <div className="wrapper" type={modes[3].mode}>
                  <div className="content">
                    <div className='info-text' dangerouslySetInnerHTML={{__html: this.l10n('CREDIT_QUICK_CASH_INFO_TEXT')}}></div>
                    <div id="zero">
                      <UsageBlock isMobile={isMobile} page={"quick-cash"} data={quick_cash_usage_block_5} className="col-3-row-2"/>
                    </div>
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("CREDIT_QUICK_CASH_HOW_TO_6_TITLE")}</div>
                      <HowToBlock data={howToItems_5} isMobile={isMobile} page={"shoping-atb"}/>
                      <a className='link mt mb' href={quickCashCalcFile_3} target='_blank' >{this.l10n('CREDIT_QUICK_CASH_HOW_TO_5_LINK')}</a>
                    </div>
                    <div id="salaryplus">
                      <UsageBlock isMobile={isMobile} page={"quick-cash"} data={quick_cash_usage_block_4} className="col-3-row-2"/>
                    </div>
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("CREDIT_QUICK_CASH_HOW_TO_5_TITLE")}</div>
                      <HowToBlock data={howToItems_4} isMobile={isMobile} page={"shoping-atb"}/>
                      <div className='link mt mb' onClick={this.scrollToCalculator}>{this.l10n('CREDIT_QUICK_CASH_HOW_TO_5_LINK')}</div>
                    </div>
                    <div id="cashcomfort">
                      <UsageBlock isMobile={isMobile} page={"quick-cash"} data={quick_cash_usage_block_2} className="col-3-row-2"/>
                    </div>
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("CREDIT_QUICK_CASH_HOW_TO_2_TITLE")}</div>
                      <HowToBlock data={howToItems_2} isMobile={isMobile} page={"shoping-atb"}/>
                      <a className='link mt mb' href={quickCashCalcFile_1} target='_blank' >{this.l10n('CREDIT_QUICK_CASH_HOW_TO_2_LINK')}</a>
                    </div>
                    <div id="addcash">
                      <UsageBlock isMobile={isMobile} page={"quick-cash"} data={quick_cash_usage_block_3} className="col-3-row-2"/>
                    </div>
                    <div className="how-to-block-wrapper">
                      <div className="block-title">{this.l10n("CREDIT_QUICK_CASH_HOW_TO_4_TITLE")}</div>
                      <HowToBlock data={howToItems_3} isMobile={isMobile} page={"shoping-atb"}/>
                      <a className='link mt ' href={quickCashCalcFile_2} target='_blank' >{this.l10n('CREDIT_QUICK_CASH_HOW_TO_3_LINK')}</a>
                    </div>
                  </div>
                </div>
              </TabsNew>
              <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
              <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}></TextAboveFooter>
              </div>
                {modal}
              {mobileOrderBtn}
            </div>
        );
}
